import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { FaqService } from './services/faq.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent implements OnInit {
  private readonly faqService = inject(FaqService);

  data$ = this.faqService.faqData$;

  ngOnInit(): void {
    this.faqService.getFaq();
  }
}
